// @ts-nocheck legacy file transformed to TS
import React from 'react'
import styled from '@emotion/styled'
import { Button, colors, Text } from 'ic-snacks'
import Modal from 'legacy/components/Modal'
import FlexColumn from 'legacy/components/FlexColumn'
import FlexRow from 'legacy/components/FlexRow'
import hamburgerImageSrc from 'assets/hamburger@2x.png'
import canImageSrc from 'assets/can@2x.png'
import lemonImageSrc from 'assets/lemon@2x.png'
import { trackEvent } from 'utils/events/trackEvent'

const InfosContainer = styled(FlexColumn)`
  background: #f7f7f7;
  border-radius: 5px;
  justify-content: space-between;
  padding: 30px 30px;
  height: 100%;
`

const TypeColumn = styled.div`
  display: flex;
  flex: 1;
  min-height: 350px;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  background: white;
  padding: 20px 20px;
  border-radius: 5px;
  margin: 0 10px;
`

const GlyphsContainer = styled(FlexRow)`
  width: 160px;
`

const Glyph = styled.img`
  height: 50px;
  margin-top: 20px;
`

const TypeCopy = styled.p`
  line-height: 32px;
  margin-top: 30px;
  color: ${colors.GRAY_46};
`

const Strong = styled.span`
  font-weight: bold;
  color: ${colors.GRAY_20};
`

const iconByTag = {
  'in-house': hamburgerImageSrc,
  universal: canImageSrc,
  commodity: lemonImageSrc,
}

class ProductInfoTypeModal extends React.Component {
  state = {
    modalIsOpen: false,
  }

  handleClose = () => {
    this.setState({
      modalIsOpen: false,
    })
  }

  handleOpen = () => {
    trackEvent({
      id: 'catalog.products.product_details.form_info.viewed',
      description:
        'Viewed the "editable product details" description section of the product details page',
    })

    this.setState({
      modalIsOpen: true,
    })
  }

  render() {
    return (
      <React.Fragment>
        <Button
          style={{ alignSelf: 'center' }}
          size="small"
          snacksStyle="flat"
          onClick={this.handleOpen}
        >
          {"Why can't I edit this?"}
        </Button>
        {this.state.modalIsOpen && (
          <Modal width={900} height={460} isOpen onClose={this.handleClose}>
            {(ModalHeader, Body) => [
              null,
              <Body>
                <InfosContainer>
                  <FlexRow>
                    <Text
                      variant="T.18"
                      fontWeight="semiBold"
                      style={{ color: colors.GRAY_20, marginBottom: 20 }}
                    >
                      Catalog Product Edits
                    </Text>
                  </FlexRow>
                  <FlexRow>
                    <TypeColumn>
                      <Text variant="T.16">Editable</Text>
                      <FlexRow>
                        <Glyph src={iconByTag['in-house']} />
                      </FlexRow>
                      <FlexRow>
                        <TypeCopy>
                          These products are usually made in-house or are private label. These are
                          yours alone and you are{' '}
                          <Strong>free to edit the information directly</Strong> without going
                          through an approval process! You are responsible for proofreading your own
                          edits.
                        </TypeCopy>
                      </FlexRow>
                    </TypeColumn>
                    <TypeColumn>
                      <Text variant="T.16">Not Editable</Text>
                      <GlyphsContainer>
                        <Glyph src={iconByTag.universal} />
                        <Glyph src={iconByTag.commodity} />
                      </GlyphsContainer>
                      <FlexRow>
                        <TypeCopy>
                          These products are typically universal that are shared across multiple
                          Retail Partners. Some properties, such as Brand, Size, or UPC codes, are{' '}
                          <Strong>not available for editing</Strong>. The information for these are
                          owned by third party agencies or the manufacturers.
                        </TypeCopy>
                      </FlexRow>
                    </TypeColumn>
                  </FlexRow>
                </InfosContainer>
              </Body>,
              null,
            ]}
          </Modal>
        )}
      </React.Fragment>
    )
  }
}

export default ProductInfoTypeModal
